import PreLoader from 'preloader';
require ('./gadgets.less');

jQuery(function () {

    $(document).on('click', '.js-thread_recount', function(e) {
        e.preventDefault();
        const loader = new PreLoader();
        loader.show();
        var threadID = $(this).data('thread');
        $.ajax({
            url: "/ajax/action/maximaster:gadget.thread_buttons/threadRecount/?threadParams=" + threadID,
            success: function (result) {
                if (result.code === 200) {
                    $('.js-thread-gadget_container').html(result.html);
                }
                loader.hide(0);
            },
            error: function() {
                loader.hide(0);
            }
        });
    });

    $(document).on('click', '.js-brand_sections-update', function(e) {
        e.preventDefault();
        const loader = new PreLoader();
        loader.show();
        var elementID = $(this).data('element');
        $.ajax({
            url: "/ajax/action/maximaster:gadget.brand_section_products/productsSectionUpdate/?element=" + elementID,
            success: function (result) {
                if (result.code === 200) {
                    $('.js-brand_sections-gadget_container').html(result.html);
                }
                loader.hide(0);
            },
            error: function() {
                loader.hide(0);
            }
        });
    });

    $(document).on('click', '.js-quantity-rule-calculate-one, .js-quantity-rule-calculate-all, .js-recalculate-abc-rating', function(e) {
        e.preventDefault();
        const loader = new PreLoader();
        loader.show();
        const $button = $(this);
        const url = $button.attr('href');

        $.ajax({
            url: url,
            success: function (result) {
                if (result.code === 200) {
                    $button.parent().html(result.message);
                } else {
                    alert('Произошла ошибка во время выполнения запроса' + result.message);
                }
                loader.hide(0);
            },
            error: function() {
                loader.hide(0);
            }
        });
    });

    $(document).on('click', '.js-download-abc-report', function(e) {
        e.preventDefault();
        const loader = new PreLoader();
        loader.show();
        const $button = $(this);
        const url = $button.attr('href');

        $.ajax({
            url: url,
            success: function (result) {
                if (result.code === 200 && result.message) {
                    window.location.href = result.message;
                } else {
                    alert('Произошла ошибка во время выполнения запроса' + result.message);
                }
                loader.hide(0);
            },
            error: function() {
                loader.hide(0);
            }
        });
    });

    $(document).on('click', '.js-clear-cache-gadget__action', function(e) {
        e.preventDefault();
        const loader = new PreLoader();
        loader.show();

        $.ajax({
            url: "/ajax/action/maximaster:gadget.clear_catalog_tag_cache/clear/",
            success: function (result) {
                if (result.code === 200 && result.message) {
                    $('.js-clear-cache-gadget_container').html(result.message);
                } else {
                    alert('Произошла ошибка во время выполнения запроса');
                }
                loader.hide(0);
            },
            error: function() {
                loader.hide(0);
            }
        });
    });

    $(document).on('click', '.js-clear-cache-smart-filter-gadget__action', function(e) {
        e.preventDefault();
        const loader = new PreLoader();
        loader.show();

        $.ajax({
            url: "/ajax/action/maximaster:gadget.clear_smart_filter_tag_cache/clear/",
            success: function (result) {
                if (result.code === 200 && result.message) {
                    $('.js-clear-cache-smart-filter-gadget_container').html(result.message);
                } else {
                    alert('Произошла ошибка во время выполнения запроса');
                }
                loader.hide(0);
            },
            error: function() {
                loader.hide(0);
            }
        });
    });

    $(document).on('click', '.js-yandex-zen-xml-genereation_link', function(e) {
        e.preventDefault();
        const loader = new PreLoader();
        loader.show();
        const $button = $(this);
        const url = $button.attr('href');

        $.ajax({
            url: url,
            success: function (result) {
                if (result.code === 200 && result.message) {
                    $('.js-yandex-zen-xml-genereation_container').html(result.message);
                } else {
                    alert('Произошла ошибка во время выполнения запроса' + result.message);
                }
                loader.hide(0);
            },
            error: function() {
                loader.hide(0);
            }
        });
    });

});


// WEBPACK FOOTER //
// ./blocks/gadgets/gadgets.js